import { render, staticRenderFns } from "./DownloadableResourcesContent.vue?vue&type=template&id=1a76c9c5"
import script from "./DownloadableResourcesContent.vue?vue&type=script&lang=js"
export * from "./DownloadableResourcesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports